import { render, staticRenderFns } from "./CreateWo.vue?vue&type=template&id=195b507b"
import script from "./CreateWo.vue?vue&type=script&lang=js"
export * from "./CreateWo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports